import React from 'react';
import styled from 'styled-components';
import { Dropdown } from 'semantic-ui-react';
import { getScrollBarStyles } from '../../config/styles';

const MentionContainer = styled(({ windowPosition, dropdownRef, ...props }) => (
  <Dropdown {...props} ref={dropdownRef} />
))`
  &&&& {
    cursor: default;
    position: fixed;
    left: ${({ windowPosition }) =>
      windowPosition && windowPosition.left
        ? `${windowPosition.left}px`
        : `calc(100vw - 299px)`};
    bottom: ${({ windowPosition }) =>
      windowPosition && windowPosition.top
        ? `${window.innerHeight - windowPosition.top + 20}px`
        : `98px`};
    width: 298px;
    padding: 0 8px;
    padding-inline-start: 0px;

    border: solid 1px #cccccc !important;
    border-radius: 4px !important;
    background-color: #f8f8f8;
    box-shadow: -1px -1px 4px 0 rgba(0, 0, 0, 0.1) !important;

    &&& > .text {
      font: inherit;
      font-size: 11px;
      font-weight: 600;
      color: #999999;
      line-height: 2.2;
      cursor: default;
      padding-left: 12px;
    }

    &&& > .icon {
      color: #ccc;
      font-size: 10px;
      float: right;
      line-height: 1;
      margin: 7px 0 0 0;
    }

    > .menu.visible {
      border: solid 1px #cccccc;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      position: relative !important;
      max-height: calc(40 * 4px);
      width: 298px;
      box-shadow: -1px 1px 4px 0 rgba(0, 0, 0, 0.1);
      > .item {
        padding: 13px 12px !important;
        font: inherit;
        font-size: 14px;
        font-weight: 500;
        color: #333333;
        border: none;
        background: #fff;
        > .image {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          vertical-align: baseline;
          margin-right: 8px;
        }
        &.active {
          background: #0076ea !important;
          color: #fff !important;
          z-index: 100 !important;
          font: inherit !important;
          font-size: 14px !important;
          font-weight: 600 !important;
        }
      }

      ${getScrollBarStyles(4)}
    }
  }
`;

interface IUser {
  id: string;
  name: string;
  email: string;
  picture: string;
  lastLogin: string;
  selected: boolean;
}

interface IWindowProps {
  position: any;
  top: number;
  left: number;
}
interface IProps {
  userList: IUser[];
  confirmMessage: (selectedCandidate: IUser) => void;
  windowPos: IWindowProps | null;
  userSelectedIndex: number;
  setUserSelectedIndex: (index: number) => void;
  openDropdown: boolean;
  dropdownRef: any;
  preventMouseHover: boolean;
}

export default function Mention(props: IProps) {
  const {
    setUserSelectedIndex,
    confirmMessage,
    userList,
    userSelectedIndex,
    openDropdown,
    preventMouseHover,
  } = props;

  return (
    <MentionContainer
      dropdownRef={props.dropdownRef}
      windowPosition={props.windowPos}
      className={'Dropdown-users'}
      icon={'sort'}
      value={userSelectedIndex}
      open={openDropdown}
      text={'Colleague list'}
      selection
      selectOnNavigation={true}
      options={userList.map((user, index) => {
        const { name, picture } = user;
        const active = index === userSelectedIndex;
        return {
          name,
          active,
          key: index,
          text: name,
          value: index,
          image: picture,
          onMouseDown: () => {
            confirmMessage(userList[index]);
          },
          onMouseOver: () => {
            // Do not take action if hover efect is disabled
            if (preventMouseHover) {
              return;
            }
            setUserSelectedIndex(index);
          },
        };
      })}
    />
  );
}
